import React, { useState } from 'react';
import { CachedImage } from '@/presentation/components/common/CachedImage';
import { UserUtils } from '@/domain/utils/userUtils';

export interface IdentityBadgeProps {
  userId: string;
}
// TODO: Wire IdentityBadge into the following surfaces once their underlying features land on web:
//   - Inbox / messages list item — Flutter: messages_chat_item.dart:117
export const IdentityBadge: React.FC<IdentityBadgeProps> = ({ userId }) => {
  const [hidden, setHidden] = useState(false);

  if (hidden) {
    return null;
  }

  return (
    <CachedImage
      src={UserUtils.generateUserIdentityVerificationBlueBadgeUrl(userId)}
      alt=""
      // Do not set dimensions on the badge image to avoid allignment issues
      // if displayed next to a text field, when the image is missing 
      // from the server. Currently, if the user has not verified its
      // identity, a 1px x 1px is available in the storage bucket. 
      // Instead, use objectFit: 'contain' to ensure it fits 
      // within its container without overflowing or causing layout shifts.
      style={{ objectFit: 'contain' }}
      placeholder={<span style={{ display: 'inline-block' }} />}
      errorPlaceholder={<></>}
      onError={() => setHidden(true)}
    />
  );
};
